// Forces a CSS class onto <html> on mount and persists the choice in
// localStorage so it sticks after leaving the page. The defaults collapse the
// desktop sidebar (used on the session view, where horizontal space is at a
// premium), but both the class and the storage key are configurable via data
// attributes, so the hook can drive any persisted document-level toggle:
//
//   <div phx-hook="CollapseSidebar"
//        data-class="sidebar-collapsed"
//        data-storage-key="sidebar-collapsed" />
export const CollapseSidebar = {
  mounted() {
    const className = this.el.dataset.class || "sidebar-collapsed";
    const storageKey = this.el.dataset.storageKey || "sidebar-collapsed";

    document.documentElement.classList.add(className);
    try {
      localStorage.setItem(storageKey, "true");
    } catch {
      // localStorage may be unavailable (e.g. private mode); ignore.
    }
  },
};
